import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { IBaseDisbursementStatusPill } from '../IBaseDisbursementStatusPill';
import { assertValueIsOfType } from 'utilities/Assertions';
import React from 'react';
import { BaseStatusPill } from '../shared/BaseStatusPill';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';

export const getAchPillDetails = (ach: IACHDisbursementFormData) => {
  switch (true) {
    case !!ach.voidedAt:
      return 'Void';
    case !!ach.completedAt || !!ach.disbursedAt:
      return 'Disbursed';
    case !!ach.sentAt:
      return 'Initiated';
    case !!ach.holdback:
      return 'Holdback';
    default:
      return 'Staged';
  }
};

export const ACHStatusPill: React.FC<IBaseDisbursementStatusPill> = ({ disbursement, amountMismatch }) => {
  assertValueIsOfType<IACHDisbursementFormData>(
    disbursement,
    () => disbursement.type === 'ACH',
    `I was supposed to only be passed a check and I was passed a ${disbursement.type} instead`
  );

  const status = getAchPillDetails(disbursement);
  const dateForTooltip = disbursement.completedAt ?? disbursement.disbursedAt ?? disbursement.sentAt;
  const dateDisplay = dateForTooltip ? getDateString(DateFormat.short, dateForTooltip) : undefined;
  return (
    <BaseStatusPill
      data-test-id={`ach-status-pill-${disbursement.id}`}
      status={status}
      text={'ACH'}
      amountCents={disbursement.amountCents}
      id={disbursement.id}
      hasWarning={amountMismatch}
      title={dateDisplay}
    />
  );
};
